<template>
  <v-switch
    hide-details
    v-model="value"
    :loading="loading"
    inset
    label="Administrateur·ice de l'établissement ? "
    @change="envoyerChangerEstAdministrateur"
  />
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    estAdministrateur: {
      type: Boolean,
      required: true,
    },
    employeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      value: this.estAdministrateur,
      loading: false,
    }
  },
  methods: {
    ...mapActions({
      changerEstAdministrateur: 'employe/changerEstAdministrateur',
    }),
    envoyerChangerEstAdministrateur(estAdministrateur) {
      this.loading = true
      this.changerEstAdministrateur({
        _employeId: this.employeId,
        estAdministrateur: estAdministrateur,
      }).then((res) => {
        this.loading = false
        this.value = res.administrateur
      })
    },
  },
}
</script>
